import { OrganisationFieldPermissions } from '@/types'

export const PHONE_INPUT_MASK = [
  '+',
  '3',
  '7',
  '5',
  ' ',
  '(',
  /[1-9]/,
  /\d/,
  ')',
  ' ',
  /\d/,
  /\d/,
  /\d/,
  '-',
  /\d/,
  /\d/,
  '-',
  /\d/,
  /\d/,
]

export const PHONE_REGEXP = /^\+375 \([1-9]\d\) \d{3}-\d{2}-\d{2}$/

export const FORM_VALIDATION_ERROR_MESSAGES = {
  REQUIRED_FIELD_MESSAGE: 'Это поле обязательное для заполнения',
  READONLY_FIELD_MESSAGE: 'Это поле неизменяемо',
  EMAIL_WRONG_FORMAT_MESSAGE: 'Неверный формат почты',
  PHONE_WRONG_FORMAT_MESSAGE: 'Неверный формат телефона',
  PASSWORDS_MISMATCH_MESSAGE: 'Пароли не совпадают',
  PASSWORD_WRONG_FORMAT_MESSAGE: 'Пароль должен содержать минимум 6 символов',
  VAT_NUMBER_WRONG_FORMAT_MESSAGE: 'УНП должен состоять из 9 символов',
  REQUIRED_POLICY_MESSAGE: 'Дайте свое согласие с политикой конфиденциальности',
}

export const NAME_VALIDATION_REGEX =
  /^[a-zA-Zа-яА-ЯёЁ][a-zA-Zа-яА-ЯёЁ\s-]{0,48}[a-zA-Zа-яА-ЯёЁ]$/

export const NAME_ERROR_MESSAGE =
  'Используйте только буквы (минимум 2). Символы и цифры запрещены'

export const REQUIRED_FIELD_MESSAGE = 'Это поле обязательное для заполнения'

export const READONLY_FIELD_MESSAGE = 'Это поле неизменяемо'

export const GENERAL_ZOD_ERROR_MESSAGE =
  'Произошла ошибка при обработке данных с сервера'

export const GENERAL_ERRORS_MESSAGES: { [x: string]: string } = {
  DEFAULT_ERROR: 'Произошла ошибка. Попробуйте позже',
  ZOD_ERROR: 'Произошла ошибка при обработке данных с сервера',
  '400_ERROR': 'Ошибка 400. Неверный запрос. Попробуйте позже',
  '401_ERROR': 'Необходимо авторизоваться заново',
  '403_ERROR': 'У вас недостаточно прав для выполнения этого действия',
  '404_ERROR': 'Ошибка 404. Запрашиваемый ресурс отсутствует. Попробуйте позже',
  '405_ERROR': 'Ошибка 405. Нет доступа к запрашиваемому ресурсу',
  '500_ERROR': 'Ошибка 500. Произошла ошибка на сервере. Попробуйте позже',
  '503_ERROR':
    'Ошибка 503. Сервер не готов обработать запрос в данный момент. Попробуйте позже',
}

export const FIELD_LABELS: Record<string, string> = {
  CONTRACT: 'Договор',
  CONSTRUCTION_SITE: 'Объект',
  DESTINATION_STORE: 'Склад назначения',
}

export const FIELD_PERMISSION_MAP: Record<
  string,
  keyof OrganisationFieldPermissions
> = {
  description: 'canEditDescription',
  vatNumber: 'canEditVatNumber',
  fullLegalName: 'canEditFullLegalName',
  shortLegalName: 'canEditShortLegalName',
  legalAddress: 'canEditLegalAddress',
  postalAddress: 'canEditPostalAddress',
  phoneNumber: 'canEditPhoneNumber',
  email: 'canEditEmail',
  emailDistribution: 'canEditEmailDistribution',
  registrationDate: 'canEditRegistrationDate',
  ipRegistrationDate: 'canEditIpRegistrationDate',
  signatoryFullName: 'canEditSignatoryFullName',
  signatoryOperatesUnder: 'canEditSignatoryOperatesUnder',
  signatoryPosition: 'canEditSignatoryPosition',
  supervisorManager: 'canChangeSupervisor',
  mainBankAccount: 'canChangeMainBankAccount',
}
